var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kdx-modal-frame',{attrs:{"value":_vm.value,"title":"商品备注","isOk":false},on:{"on-cancel":_vm.handleCancel}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"remark-content",domProps:{"innerHTML":_vm._s(_vm.data)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }